import "./top-bar.css";
import MainLogo from "../svg/main_logo.png";
import { useNavigate } from "react-router-dom";
import UseAnimations from "react-useanimations";
import { logIn, phoneCall, shoppingCart, smile, users } from "react-useanimations/icons";
import menu2 from "react-useanimations/lib/menu2";
import { useState } from "react";

const TopBar = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className={window.location.pathname.startsWith("/documents") ? "topBar dark" : "topBar"}>
      <div onClick={() => navigate("/")} className="topBar_mainLogo">
        <img src={MainLogo}></img>
      </div>

      <div className="topBar_menu">
        <div className={window.location.pathname == "/services" ? "active" : ""} onClick={() => navigate("/services")}>
          Услуги
        </div>
        <div
          onClick={() => {
            document
              .getElementById("main_scroll")
              .scrollTo({ top: document.getElementById("main_scroll").scrollHeight, behavior: "smooth" });
          }}
        >
          Отзывы
        </div>
        <div>Контакты</div>
        <div>О нас</div>
      </div>

      <div className="topBar_rightBlock">
        <div className="topBar_LogIn">
          <UseAnimations interaction="hover" animation={logIn} size={32} />
          <span>Войти</span>
        </div>

        <div className="topBar_phone">
          <span>+7(999)800-71-02</span>
          <span>с 9:00 до 23:00 без выходных</span>
        </div>

        <div
          className="topBar_menu_mobile"
          onClick={() => {
            setMobileMenuOpen((prev) => !prev);
          }}
        >
          <UseAnimations animation={menu2} size={32} />
        </div>
      </div>

      <div className={mobileMenuOpen ? "mobileMenu open" : "mobileMenu close"} id="mobileMenu">
        <div className="mobileMenu_elem">
          <UseAnimations interaction="loop" animation={shoppingCart} size={28} />
          <span>Услуги</span>
        </div>
        <div className="mobileMenu_elem">
          <UseAnimations interaction="loop" animation={smile} size={28} />
          <span>Отзывы</span>
        </div>
        <div className="mobileMenu_elem">
          <UseAnimations interaction="loop" animation={phoneCall} size={28} />
          <span>Контакты</span>
        </div>
        <div className="mobileMenu_elem">
          <UseAnimations interaction="loop" animation={users} size={28} />
          <span>О Нас</span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
